import _api from '../_api';

import Driver from '../../../models/Driver';
import DriverReport from '../../../models/DriverReport';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    drivers: [],
    reports: [],
    assignableDrivers: [],
    pageCount: 0,
    totalCount: 0,
    reportsPageCount: 15,
  },
  // -----------------------------------------------------------------
  getters: {
    all: (state,) => state.drivers,
    assignable: (state,) => state.assignableDrivers,
    reports: (state,) => state.reports,
    filteredReports: (state,) => (filters,) => state.reports.filter((item,) => {
      let confirmation = true;
      Object.entries(filters,).forEach((filter,) => {
        if (filter[1]) {
          if (typeof filter[1] === 'string') {
            confirmation = item[filter[0]].
              toLowerCase().indexOf(filter[1].toLowerCase(),) >= 0;
          } else {
            confirmation = item[filter[0]] === filter[1];
          }
        }
      },);
      return confirmation;
    },),
    reportsPageCount: (state,) => state.reportsPageCount,
    reportsTotalCount: (state,) => state.reports.length,
    pageCount: (state,) => state.pageCount,
    totalCount: (state,) => state.totalCount,
  },
  // -----------------------------------------------------------------
  mutations: {
    setDrivers: (state, drivers,) =>
      (state.drivers = drivers.map((driver,) => new Driver(driver,),)),
    setAssignableDrivers: (state, assignableDrivers,) =>
      (state.assignableDrivers = assignableDrivers),
    setDriverReports: (state, reports,) => (state.reports = reports),
    setPageCount: (state, pageCount,) => (state.pageCount = pageCount),
    setTotalCount: (state, totalCount,) => (state.totalCount = totalCount),
    setReportsPageCount: (state, reportsPageCount,) =>
      (state.reportsPageCount = reportsPageCount),
    setReportsTotalCount: (state, reportsTotalCount,) =>
      (state.reportsTotalCount = reportsTotalCount),
  },
  // -----------------------------------------------------------------
  actions: {
    get: (
      { commit, },
      {page, full_name, cpf, phone, dispatch_type, sort, sortBy, status,},
    ) => {
      commit('drivers/setDrivers', [], { root: true, },);
      return _api.get(
        {
          fields: 'full_name,phone,address,dispatch_type,last_order,average_rating,status',
          page,
          full_name,
          cpf,
          phone,
          dispatch_type,
          sort,
          sortBy,
          status,
        },
      ).then(
        (response,) => {
          const drivers = response.data.items.map((driver,) => new Driver(driver,),);

          commit('drivers/setDrivers', drivers, { root: true, },);
          commit(
            'drivers/setPageCount',
            Math.ceil(response.data.total_count / 15,),
            { root: true, },
          );
          commit('drivers/setTotalCount', response.data.total_count, {
            root: true,
          },);

          return drivers;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    getGlobalDrivers: (
      { commit, },
      { page, address, full_name, cpf, dispatch_type, phone, sort, sortBy, status, },
    ) => {
      _api.unsetFranchise();
      return _api.get({
        fields: 'full_name,phone,address,dispatch_type,last_order,average_rating,status',
        page,
        address,
        full_name, cpf,
        dispatch_type,
        phone,
        sort,
        sortBy,
        status,
      },).
        then((response,) => {
          const drivers = response.data.items.map((driver,) => new Driver(driver,),);

          commit('drivers/setDrivers', drivers, { root: true, },);
          commit(
            'drivers/setPageCount',
            Math.ceil(response.data.total_count / 15,),
            { root: true, },
          );
          commit('drivers/setTotalCount', response.data.total_count, {
            root: true,
          },);

          return drivers;
        },).
        catch((error,) => {
          return _api.handleError(error,);
        },);
    },
    getDraftByCpf: (_, { cpf, },) => {
      return _api.getDraftByCpf({ cpf, },).then(
        (response,) => {
          return response;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    getAssignableDrivers: ({ commit, rootState, },) => {
      commit('drivers/setAssignableDrivers', [], { root: true, },);
      return _api.getAssignableDrivers().then(
        (response,) => {
          const drivers = [
            {
              text: 'Todos entregadores',
              key: 'ALL',
              checked: false,
            },
            ...response.data.items.map((driver,) => {
              const newDriver = new Driver(driver,);
              newDriver.checked = Boolean(
                rootState.
                  store.assignedDrivers.find((driver,) => driver._id === newDriver._id,),
              );
              newDriver.text = driver.full_name;
              return newDriver;
            },),
          ];

          commit('drivers/setAssignableDrivers', drivers, { root: true, },);
          return drivers;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    getReports: ({ commit, }, { begin_date, end_date, },) => {
      commit('drivers/setDriverReports', [], { root: true, },);

      return new Promise((resolve, reject,) => {
        _api.
          getDriverReports({ begin_date, end_date, },).then(
            (response,) => {
              const reports = response.data.items.
                map((report,) => new DriverReport(report,),);
              commit('drivers/setDriverReports', reports, { root: true, },);
              commit(
                'drivers/setReportsPageCount',
                Math.ceil(response.data.total_count / 15,),
                { root: true, },
              );
              commit('drivers/setReportsTotalCount', response.data.total_count, {
                root: true,
              },);

              return resolve(reports,);
            },
          ).catch((error,) => error.response?.status === 400 ?
            reject(error.response.data.errors[0],) : _api.handleError(error,),);
      },);
    },
    create: (_, value,) => {
      const newDriver = new Driver(value,);

      return new Promise((resolve, reject,) => {
        _api.
          post(newDriver.toPost,).
          then((inserted,) => {
            resolve(new Driver(inserted,),);
          },).
          catch((error,) => {
            reject(error.response,);
          },);
      },);
    },
    createDraft: (_, { draft, },) => {
      return new Promise((resolve, reject,) => {
        _api.
          postDraft(draft,).
          then((inserted,) => {
            resolve(inserted,);
          },).
          catch((error,) => {
            reject(error.response,);
          },);
      },);
    },
    exportReport: async (_, { driverIds, begin_date, end_date, },) => {
      return new Promise((resolve, reject,) => {
        _api.
          exportDriverReports({ driverIds, begin_date, end_date, },).
          then((response,) => {
            resolve(response.data.message,);
          },).
          catch((error,) => {
            console.log('---------------',);
            return error.response?.status === 400 ?
              reject(error.response,) : _api.handleError(error,);
          },);
      },);
    },
    updateDriverStatuses: async (_, { driverIds, status, },) => {
      return new Promise((resolve, reject,) => {
        _api.
          updateDriverStatuses({ driverIds, status, },).
          then((response,) => {
            resolve(response.data,);
          },).
          catch((error,) => {
            return error.response?.status === 400 ?
              reject(error.response,) : _api.handleError(error,);
          },);
      },);
    },

    updateOccurrenceStatuses: async (_, {driverId, OccIds, status, },) => {
      return new Promise((resolve, reject,) => {
        _api.patchOccurrenceStatuses({ driverId, OccIds, status, },).
          then((response,) => resolve(response.data,),).
          catch((error,) => {
            return error.response?.status === 400 ?
              reject(error.response,) : _api.handleError(error,);
          },);
      },);
    },

    updateDocs: async ({ rootGetters, }, { attachments, cpf, },) => {
      return new Promise((resolve, reject,) => {
        _api.
          updateDriverDocs({ _id: rootGetters['driver/actual']?._id, attachments, cpf, },).
          then((response,) => resolve(response.data,),).
          catch((error,) => {
            return error.response?.status === 400 ?
              reject(error.response,) : _api.handleError(error,);
          },);
      },);
    },
    updateAddress: async ({ rootGetters, }, { address, },) => {
      return new Promise((resolve, reject,) => {
        _api.
          updateDriverAddress({ _id: rootGetters['driver/actual']?._id, address, },).
          then((response,) => resolve(response.data,),).
          catch((error,) => {
            return error.response?.status === 400 ?
              reject(error.response,) : _api.handleError(error,);
          },);
      },);
    },
  },
};
